import { Component, OnInit } from '@angular/core';
import { AdminService } from './admin.service';
import { Router, ActivatedRoute} from '@angular/router';
import { CommonDataService, KeyValuePair } from '../common-data/commondata.service';
import { UserSession } from '../shared/user-session';
import * as _ from 'lodash';


@Component({
    providers: [AdminService],
    //templateUrl: 'app/administration/user.component.html'
    template: require('./userrolerequest.component.html'),
})
 
export class UserRoleRequestComponent implements OnInit {
    
    alerts: any[]; 
    public origUser: any;
    private sub: any;
    private idParam: number;
    //this may actually need to be public
    private newUser: boolean; 
    pageTitle: string;
    user: any;
    roles: any; 
    justification: any;
    regions: KeyValuePair[]; 
    
    constructor(private router: Router,
        private adminService: AdminService, 
        private _commonDataService: CommonDataService,
        private _User: UserSession,
        private route: ActivatedRoute) {}    
 
    ngOnInit() : void{

        this.sub = this.route.params.subscribe(
            params => {
            let id = this._User.getSession()['id'];

                this.pageTitle = 'Elevated Request';

                this.idParam = id;

                this.adminService.getUser(id.toString()).subscribe(
                    data => {
                        this.user = data;
                        this.origUser = _.cloneDeep(this.user);                                                
                        this.getRoles();
                        
                    });
        });
        
        this.getKeyValues('region');
    }

    private getKeyValues(id: string)
    {
        this._commonDataService.getData(id)
            .subscribe(
                (list: KeyValuePair[]) => {
                    if(id == "region"){
                        this.regions = list;
                    }
                }
            );
    }

    getRoles(){
        this.adminService.getRoles()
            .subscribe(
                roles => {
                   this.roles = _.sortBy(roles, 'id');                   
                   this.roles.find(item => item.id == 5).name = "Power User";
                   this.roles.find(item => item.id == 7).name = "TAF Liaison";
                   this.selectRole();                   
            });        
    }

    selectRole(){
        if(this.user && this.user.roles){
            let roleId = this.user.roles[0].id;
                this.user.selectedRole = _.find(this.roles, function(role: any){
                    return role.id === roleId;
                });            
		}else{	    
            this.user.selectedRole = this.roles[1];
		}       
	}

    submitUser(){

        this.alerts = [];

        if (this.user.role == 7 && this.user.regCode == null) {
            this.alerts.push({type: 'danger', msg: 'Regional Manager required region.'});
        } else if (this.user.role == null) {
            this.alerts.push({type: 'danger', msg: 'Role is required.'});
        } else {
            if (this.user.role == null) 
                this.user.role = this.user.selectedRole.id;
                this.adminService.submitrequest(this.user)
                .subscribe(
                    success => {
                        //this.router.navigate(['/welcome']), 
                        if (String(success).includes("ERROR"))
                            this.alerts.push({type: 'danger', msg: success}); 
                        else
                            this.alerts.push({type: 'success', msg: 'Request Submitted.'});                             
                    },
                    error => {
					    this.alerts.push({type: 'danger', msg: 'Update failed.'});
                    });
        }
    }

	resetForm(){			
        this.router.navigate(['/welcome']);
		//this.user = this.origUser;
		//this.selectRole();
        //https://github.com/angular/angular/pull/9974
		//this.form.markAsPristine();
	}

	closeAlert(index: any) {
        this.alerts.splice(index, 1);
    }
}




   


/** WEBPACK FOOTER **
 ** ./app/administration/userrolerequest.component.ts
 **/